import { render, staticRenderFns } from "./LogoSelector.vue?vue&type=template&id=2b0ec52e&scoped=true"
import script from "./LogoSelector.vue?vue&type=script&lang=ts"
export * from "./LogoSelector.vue?vue&type=script&lang=ts"
import style0 from "./LogoSelector.vue?vue&type=style&index=0&id=2b0ec52e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0ec52e",
  null
  
)

export default component.exports